import { defineStore } from 'pinia'
import ghtkService from "@/services/ghtk.service.js";
export const useGHTKStore = defineStore('syncGHTK', {
    state: () => {
        return {
            syncGHTK: null,
            paginate: {},
            lastPage: 1,
            listSyncGHTK: [],
            lisOrderGHTK: [],
            shippingFee: 0,
            isLoading: false
        }
    },
    persist: true,
    actions: {
        async authenticateGHTK(url, params) {
            try {
                const res = await ghtkService.authenticateGHTK(url, params)
                this.syncGHTK = res.data.data
                return res.data
            } catch (e) {
                return e
            }
        },
        async getListGHTK(url, params) {
            try {
                const res = await ghtkService.getListGHTK(url, params)
                this.listSyncGHTK = res.data.data
                this.paginate = res.data.meta
                this.lastPage = res.data.meta.page
            } catch (e) {
                return e
            }
        },
        async deleteGHTK(url, params) {
            try {
                const res = await ghtkService.deleteGHTK(url, params)
                return res.data
            } catch (e) {
                return e
            }
        },
        async getSyncGHTKDetail(url, params) {
            try {
                const res = await ghtkService.getSyncGHTKDetail(url, params)
                this.syncGHTK = res.data
            } catch (e) {
                return e
            }
        },
        async createGHTKOrder(url, params) {
            try {
                const res = await ghtkService.createGHTKOrder(url, params)
                return res.data
            } catch (e) {
                return e
            }
        },
        async getShippingFee(url, params) {
            try {
                this.isLoading = true
                const res = await ghtkService.getShippingFee(url, params)
                this.shippingFee = res.data.data.fee
            } catch (e) {
                return e
            } finally {
                this.isLoading = false
            }
        },
        async createOrderThirdParty(url, params) {
            try {
                const res = await ghtkService.createOrderThirdParty(url, params)
                return res.data
            } catch (e) {
                return e
            }
        },
        async getListOrder(url, params) {
            try {
                const res = await ghtkService.getListOrder(url, params)
                this.lisOrderGHTK = res.data.data
                this.paginate = res.data.meta
                this.lastPage = res.data.meta.page
            } catch (e) {
                return e
            }
        },
        async printLabel(url, params) {
            try {
                return await ghtkService.printLabel(url, params)
            } catch (e) {
                return e
            }
        },
        async cancelOrderGHTK(url, params) {
            try {
                const res = await ghtkService.cancelOrderGHTK(url, params)
                return res.data
            } catch (e) {
                return e
            }
        },
        async changeStatus(url, params) {
            try {
                const res = await ghtkService.changeStatus(url, params)
                return res.data
            } catch (e) {
                return e
            }
        },
    }
})
